import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Col, message, Modal, Row, Table } from "antd";
import { api_fetch } from "../../V2/utils/HttpRequest/request";
import { Utilitaries } from "../../business";
import { ColumnProps } from "antd/lib/table";
import { useDeviceSelector } from "../../V2/components/FormRender/hooks/useDeviceSelector";

interface Lembrete {
    id: number;
    title: string;
    message: string;
    date: string;
    is_read: boolean;
}

export function ClientLembrete() {
    const [isOpen, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lembretes, setLembretes] = useState<Lembrete[]>([]);

    const { isDesktop } = useDeviceSelector();

    useEffect(() => {
        if (lembretes.length === 0) {
            fetchData();
        }
    }, [lembretes.length, isOpen]);

    const fetchData = async () => {
        setLoading(true);
        const result = await api_fetch({
            method: "POST",
            endPoint: "/Gestor/gerelembretes.php",
            params: {
                accao: "consultar_cliente",
            },
        });
        console.log(result);

        if (result.status === "SUCCESS") {
            const data = Utilitaries.toArray(result.response?.lembretes?.linha);
            setLembretes(data);
            console.log(data);
        } else {
            message.error("Erro ao carregar os lembretes!");
        }
        setLoading(false);
    };
    const handleOpenModel = () => {
        setOpen(!isOpen);
    };

    const seeMore = (item: Lembrete) => {
        Modal.info({
            title: item.title,
            content: (
                <div>
                    <pre style={{ whiteSpace: "pre-wrap" }}>{item.message}</pre>
                </div>
            ),
            onOk() {},
            width: "50%",
        });
    };

    const notShowLembretes = async (item: Lembrete) => {
        const result = await api_fetch({
            method: "POST",
            endPoint: "/Gestor/gerelembretes.php",
            params: {
                accao: "marcar_visto_cliente",
                ids: item.id,
            },
        });

        if (result.status === "SUCCESS") {
            fetchData();
        } else {
            message.error("Erro ao marcar como lido!");
        }
    };

    const columns: ColumnProps<Lembrete>[] = [
        {
            title: "Titulo",
            dataIndex: "title",
            key: "title",
            width: "20%",
            ellipsis: true,
            sorter: (a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
            render: (description, item) => (
                <span onClick={() => seeMore(item)} style={{ cursor: "pointer" }}>
                    {description}
                </span>
            ),
        },
        {
            title: "Mensagem",
            dataIndex: "message",
            key: "message",
            ellipsis: true,
            width: "40%",
            sorter: (a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
            render: (description, item) => (
                <span onClick={() => seeMore(item)} style={{ cursor: "pointer" }}>
                    {description}
                </span>
            ),
        },
        {
            title: "Data",
            dataIndex: "date",
            key: "date",
            render: (data) => data,
            sorter: (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
            width: "20%",
        },
        {
            title: "Ação",
            render: (_, item) => (
                <Button type="link" size="small" onClick={() => notShowLembretes(item)}>
                    Não voltar a mostrar
                </Button>
            ),
            width: "20%",
        },
    ];

    return (
        <>
            <Badge className={`add-margin`} count={lembretes.length}>
                <Button onClick={handleOpenModel} icon="bell" type="link" title="Lembretes" />
            </Badge>

            <Modal
                title="Lembretes do Cliente"
                visible={isOpen}
                onCancel={handleOpenModel}
                width="90%"
                centered
                zIndex={800}
                footer={null}
            >
                {/* Renderiza a lista de lembretes do cliente */}
                {isDesktop ? (
                    <Table
                        size="small"
                        rowKey={(data) => data.id + "-lembrete-client"}
                        pagination={{
                            pageSize: 5,
                        }}
                        dataSource={lembretes}
                        columns={columns}
                        style={{ marginTop: 20 }}
                        loading={loading}
                    />
                ) : (
                    <Row gutter={[16, 16]} type="flex">
                        {lembretes.map((lembrete) => (
                            <Col xs={24} sm={24} md={12} lg={12} xl={6} key={lembrete.id}>
                                <Card
                                    title={lembrete.title}
                                    // hoverable
                                    actions={[
                                        <Button type="link" size="small" onClick={() => notShowLembretes(lembrete)}>
                                            Não voltar a mostrar
                                        </Button>,
                                    ]}
                                    size="small"
                                    style={{ height: "100%", display: "flex", flexDirection: "column" }}
                                    bodyStyle={{
                                        flexGrow: 1,
                                    }}
                                >
                                    <p>{lembrete.message}</p>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </Modal>
        </>
    );
}
